
import customAxios from "../index";
import qs from "qs";

const providerDetails = localStorage.getItem("providerDetails");
const parsed = providerDetails ? JSON.parse(providerDetails) : null;
const token = parsed?.accessToken || parsed?.access_token || "";



export const getPaymentBillingList = (params: any) => {
  return customAxios({
    method: "GET",
    url: "/admin/order-management/orders-list",
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const getPaymentBillingDetails = (id: string, timezone: string) => {
  return customAxios({
    method: "GET",
    params: {
      timezone,
    },
    url: `/admin/order-management/orders-details/${id}`,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const downloadInvoice = (id: string, timezone: string) => {
  return customAxios({
    method: "GET",
    params: {
      timezone,
    },
    url: `/admin/order-management/download-invoice/${id}`,
    responseType: "blob",
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const shareInvoice = (id: string,
  data: { timezone: string; emails: string[] }) => {
  return customAxios({
    method: "POST",
    data,
    url: `/admin/order-management/share-invoice/${id}`,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const getProvidersList = (searchText?: string) => {
  return customAxios({
    method: "GET",
    url: "/admin/order-management/provider-search",
    params: searchText ? { searchText } : {},
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const getPlannersList = (searchText?: string) => {
  return customAxios({
    method: "GET",
    url: "/admin/order-management/planner-search",
    params: searchText ? { searchText } : {},
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};


